import { removeMultipleTags } from "~/common/utils/domUtils";

type SummaryDataName = { name?: string | number | null };
type SummaryDataValue = { value?: string | number | null };
type SummaryDataItem = SummaryDataName & SummaryDataValue;

export function convertToSnakeCase(name: string) {
  return name.trim().replace(/\s+/g, "_").toLowerCase();
}

export function prepareSummaryDataName(summaryData: SummaryDataName): string;
export function prepareSummaryDataName(summaryData: string): string;
export function prepareSummaryDataName(summaryData: string | SummaryDataName) {
  let name: string;
  if (typeof summaryData === "string") {
    name = summaryData;
  } else {
    name = summaryData.name?.toString() ?? "";
  }
  name = removeMultipleTags(name, "p", "strong", "sub")!;
  // Remove "(mm)" from the name, even if there are spaces in between
  name = name.replace(/\(\s*mm\s*\)/g, "").trim();
  return convertToSnakeCase(name);
}

export function prepareSummaryDataValue(summaryData: SummaryDataValue) {
  let value = summaryData.value?.toString() ?? "";
  value = removeMultipleTags(value, "p", "strong", "sub")!;
  // Collapse whitespace into a single space
  value = value.replace(/\s+/g, " ").trim();
  return value;
}

export function prepareSummaryDataValues(values: readonly SummaryDataItem[]) {
  const result = {} as Record<string, string>;
  values.forEach((value) => {
    result[prepareSummaryDataName(value)] = prepareSummaryDataValue(value);
  });
  return result;
}
